export enum TipoDePropostaEnum {
  Licitacoes = 1,
  Contratos = 2,
  Recursal = 3,
  SME = 4,
  Civel = 5,
  Trabalhista = 6,
  Fiscal = 7,
  Adiantamento = 8,
  LicitacoesPrivado = 9,
  ContratosPrivado = 10,
  ContratoConstrucao = 11,
  ContratoFornecimento = 12,
  ContratoPrestacaoServicos = 13,
  ContratoPrivadoConstrucao = 14,
  ContratoPrivadoFornecimento = 15,
  ContratoPrivadoPrestacaoServicos = 16,
}

export enum StatusCodeAPI {
  success = 200,
  badRequest = 400,
  notFound = 404,
  internalServerError = 500,
}

export enum TabelaPropostaEnum {
  Proposta = 1,
  PropostaJudicial = 2,
  PropostaAdiantamento = 3,
  Recursal = 4,
}

export enum TipoDeProduto {
  Publico = 0,
  Privado = 1,
  Todos = 2,
}

export enum TipoMensagemModal {
  Personalizada = 0,
  PendenciaCCG = 1,
  FinalizarProposta = 2,
  SalvarAlteracoesInsert = 3,
  SalvarAlteracoesUpdate = 4,
  GerarMinutaProposta = 5,
}
